export const deploymentBase = () => (process.env.PUBLIC_URL || '').replace(/\/$/, '')

export const withDeploymentBase = (path: string) => `${deploymentBase()}${path.startsWith('/') ? path : `/${path}`}`

export const stripDeploymentBase = (pathname: string) => {
  const base = deploymentBase()
  return base && (pathname === base || pathname.startsWith(`${base}/`)) ? pathname.slice(base.length) || '/' : pathname
}
